<template>
    <div>
        <AppHomepageHero :content="heroContent" />
        <HomePageRetailers />
        <LazyStackCardsAnimation :content="stackedCards" />
        <LazyBreakNormSection />
        <LazyUserCommentsSlider />
        <ClientOnly>
            <section ref="pricing_section" class="xl:container py-10 xl:px-0">
                <PricingHomePage />
            </section>
        </ClientOnly>

        <LazyAppLandingPricingSection v-if="!useCookie('access_token').value" />
        <LazyAppApiAccess />
        <LazyRenovationToolsSlider :title="$t('pages_b2b_all_services_title')" />
        <LazyAppFaq :firstRow="faqFirstRow" :secondRow="faqSecondRow" />
        <LazyAppAboutService :item="aboutID" />
    </div>
</template>

<script setup lang="ts">
import { useHomepageSection } from "~/data/homepage";
import { useScrollIds } from "~/store/global/scrollIds";
const { aboutID, heroContent, faqFirstRow, faqSecondRow, stackedCards } = useHomepageSection();

const { pricing_section } = storeToRefs(useScrollIds());
const { t } = useI18n();

const PricingHomePage = defineAsyncComponent(() => import("~/modules/pricing/components/plans-cards/index.vue"));

// * seo
useHead({
    title: t("pages_homepage_meta_title").replace("/", "|"),
    meta: [
        {
            name: "description",
            content: t("pages_homepage_meta_desc"),
        },
    ],
    link: [
        {
            rel: "canonical",
            href: `https://aihomedesign.com${useRoute().path}`,
        },
    ],
});
</script>
